export default __webpack_public_path__ + "static/media/VEUE_Stacked Logo_RGB_White@2x.d02b36ea.png";